import React, { useEffect, useState } from 'react';

/**
 * Bloc Top Opportunities pour Asset Scanner (Phase 1)
 * Affiche les 3 à 5 meilleures opportunités du moment, avec score et signal.
 * Appel API : /api/scanner/topOpportunities
 */
const TopOpportunities = () => {
  const [opps, setOpps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchOpps() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch('/api/scanner/topOpportunities');
        if (!res.ok) throw new Error('Erreur réseau');
        const data = await res.json();
        setOpps(Array.isArray(data) ? data.slice(0, 5) : []);
      } catch (e) {
        setError('Impossible de récupérer les opportunités.');
        setOpps([]);
      } finally {
        setLoading(false);
      }
    }
    fetchOpps();
  }, []);

  const renderState = () => {
    if (loading) {
      return <div className="top-opportunities__state">Chargement des opportunités...</div>;
    }
    if (error) {
      return <div className="top-opportunities__state top-opportunities__state--error">{error}</div>;
    }
    if (!opps.length) {
      return <div className="top-opportunities__state">Aucune opportunité détectée pour l’instant.</div>;
    }

    return (
      <div className="top-opportunities__list">
        {opps.map((o) => (
          <div key={o.symbol} className="top-opportunity-card">
            <div className="top-opportunity-card__symbol">{o.symbol}</div>
            <div className="top-opportunity-card__name">{o.name}</div>
            <div className="top-opportunity-card__score">{o.score ?? '—'}</div>
            <div
              className="top-opportunity-card__signal"
              style={{
                color: o.signal === 'BREAKOUT' ? '#aa3d33' : o.signal === 'MOMENTUM' ? '#1f7a4d' : '#8d6c16',
              }}
            >
              {o.signal}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="top-opportunities">
      <div className="top-opportunities__header">
        <div>
          <div className="top-opportunities__eyebrow">Scanner highlights</div>
          <h3>Top Opportunités</h3>
        </div>
        <span className="top-opportunities__count">Top 5</span>
      </div>
      {renderState()}
    </div>
  );
};

export default TopOpportunities;
